export default "__VITE_ASSET__odwfr4G5__"